import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const isValidURL = (url) => {
  const urlRegex = /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)([\w\-\._~:/?#[\]@!$&'()*+,;=]*)?$/;
  return urlRegex.test(url);
};

const SocialAccountSettings = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [socialIDs, setSocialIDs] = useState({
    facebook_id: '',
    twitter_id: '',
    insta_id: '',
    youtube_id: '',
    snap_id: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        const userDetails = response.data.data.user_details;
        setUserData(user);
        setSocialIDs({
          facebook_id: userDetails.facebook_id,
          twitter_id: userDetails.twitter_id,
          insta_id: userDetails.insta_id,
          youtube_id: userDetails.youtube_id,
          snap_id: userDetails.snap_id
        });
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setSocialIDs((prevState) => ({
      ...prevState,
      [id]: value,
    }));

    if (!isValidURL(value)) {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        [id]: 'Please enter a valid URL.',
      }));
    } else {
      setFieldErrors((prevErrors) => {
        const { [id]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const invalidFields = Object.keys(socialIDs).filter(
      (field) => !isValidURL(socialIDs[field])
    );

    if (invalidFields.length > 0) {
      setErrorMessage('Please fix the errors in the form before submitting.');
      return;
    }

    try {
      setErrorMessage(''); // Clear previous error messages
      setSuccessMessage(''); // Clear previous success messages

      const response = await axios.post(`${config.baseURL}/update-social-id`, socialIDs, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        setSuccessMessage(response.data.message);
      } else if (response.data.error) {
        setErrorMessage(response.data.message);
      }
    } catch (error) {
      console.error('Error updating social IDs', error);
      setErrorMessage('Failed to update Social IDs');
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg
                        width={54}
                        height={54}
                        viewBox="0 0 54 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                          stroke="#222"
                          strokeWidth={6}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3>
                      <a href={`/${userData.user_name}`}>@{userData.user_name}</a>
                    </h3>
                    <ul>
                      <li>
                        <Link className="active_profile_menu" to="/EditProfile">
                          Profile <span className="menu_arrow">
                            <img src={rightarrow} alt="" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/AccountSettings">
                          Account <span className="menu_arrow">
                            <img src={rightarrow} alt="" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/PrivacySafetySettings">
                          Privacy and safety <span className="menu_arrow">
                            <img src={rightarrow} alt="" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/NotificationSettings">
                          Notifications <span className="menu_arrow">
                            <img src={rightarrow} alt="" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={handleSubmit}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <h1>SOCIAL ACCOUNTS</h1>
                  </div>
                  <div className="head_dropdown">
                    <button
                      type="submit"
                      className="create_post_btn_area post_btn"
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="fields_menu_bottom_box_edit_account edit_username_fields">
                  <div className="editable_fields_user social_account_update">
                    {Object.keys(socialIDs).map((key) => (
                      <div className="row" key={key}>
                        <div className="col-md-12">
                          <div className="mb-4 position_relative">
                            <input
                              type="text"
                              className={`form-control ${fieldErrors[key] ? 'is-invalid' : ''}`}
                              id={key}
                              value={socialIDs[key]}
                              onChange={handleInputChange}
                              required
                            />
                            <label
                              htmlFor={key}
                              className="placeholder-label"
                            >
                              {key.replace('_id', '').replace(/_/g, ' ')}
                            </label>
                            {fieldErrors[key] && (
                              <div className="invalid-feedback">
                                {fieldErrors[key]}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="message_status">
                  {errorMessage && (
                    <div className="alert alert-danger">{errorMessage}</div>
                  )}
                  {successMessage && (
                    <div className="alert alert-success">{successMessage}</div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialAccountSettings;
